import { render, staticRenderFns } from "./AttachmentDrawer.vue?vue&type=template&id=7ad010dc&scoped=true"
import script from "./AttachmentDrawer.vue?vue&type=script&lang=js"
export * from "./AttachmentDrawer.vue?vue&type=script&lang=js"
import style0 from "./AttachmentDrawer.vue?vue&type=style&index=0&id=7ad010dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad010dc",
  null
  
)

export default component.exports